import { BackgroundColor } from '@honeycomb/data';
/**
 * Maps the CMS background color property to the appropriate Honeycomb theme color.
 *
 * @param {BackgroundColor} [color] - The CMS background color to be mapped.
 * @returns {ColorOption} - The corresponding theme color value as a string.
 */
export function mapCMSBackgroundColorToThemeColor(color) {
    switch (color) {
        case BackgroundColor.Primary:
            return 'primary.base';
        case BackgroundColor.Secondary:
            return 'secondary.base';
        case BackgroundColor.Tertiary:
            return 'tertiary.base';
        case BackgroundColor.Accent:
            return 'accent.base';
        case BackgroundColor.AccentPrimary:
            return 'accentPrimary.base';
        case BackgroundColor.AccentSecondary:
            return 'accentSecondary.base';
        case BackgroundColor.AccentTertiary:
            return 'accentTertiary.base';
        case BackgroundColor.Offset:
            return 'background.offset';
        case BackgroundColor.White:
            return 'common.white';
        case BackgroundColor.Black:
            return 'common.black';
        default:
            return 'common.white';
    }
}
